import { site } from '@/config/site'

// Navigation items used by both Header (mega menu) and Footer (quick links).
// `description` powers the mega-menu hover/focus preview per Website Review V2
// (the small eyebrow header is no longer shown — description only).

export interface NavItem {
  id: string
  label: string
  href: string // anchor on the home page for Phase 1
  description: string
}

export const navItems: NavItem[] = [
  {
    id: 'work',
    label: 'Our Work',
    href: '/#work',
    description: 'Learn about GIA Longevity’s work and focus.',
  },
  {
    id: 'ecosystem',
    label: 'For Organizations',
    href: '/#ecosystem',
    description:
      'Become a LifeSpan Founding Partner and co-create across the longevity ecosystem.',
  },
  {
    id: 'partners',
    label: 'Our Partners',
    href: '/#partners',
    description:
      'Meet our Founding LifeSpan Partners, members, and strategic alliances.',
  },
  {
    id: 'media',
    label: 'Learning Hub',
    href: '/#media',
    description: 'Read, Watch, Listen. Stories and insights on aging and longevity.',
  },
  {
    id: 'about',
    label: 'About',
    href: '/#about',
    description: 'Our vision, mission, leadership, and advisory council.',
  },
  {
    id: 'contact',
    label: 'Contact',
    href: '/#contact',
    description: 'Get in touch — partnerships, resources, updates.',
  },
]

// Order per Website Review: Find Resources, Blog, Subscribe, GIA Longevity Global.
// TODO(client): Find Resources and Blog get dedicated sections in a later phase;
// they point at the closest existing anchors for now.
export const UTILITY_LINKS = [
  { label: 'Find resources', href: '/#contact', external: false },
  { label: 'Blog', href: '/#media', external: false },
  { label: 'Subscribe', href: '/#contact', external: false },
  { label: 'GIA Longevity Global', href: site.globalUrl, external: true },
]
